import {Component, inject, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgbDropdownModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { PageTitleComponent } from '@shared/components/page-title/page-title.component';
import { TranslatePipe } from '@ngx-translate/core';
import { BasicTableComponent } from '@common/references/basic-table.component';
import { Payment } from '@modules/universal-billing/accounting/payments/payments.interfaces';
import { Table } from '@primeng/table';
import { PaymentsService } from '@modules/universal-billing/accounting/payments/payments.service';
import { FormsModule } from '@angular/forms';
import { PTableCellValueComponent } from '@primeng/table/components/p-table-cell-value/p-table-cell-value.component';
import { BadgeModule } from '@primeng/badge';
import { PaymentStatus } from '@modules/universal-billing/accounting/payments/payment.enum';
import { PaymentStatusBadgeDirective } from '@common/directive/payment-status.directive';
import { MoneyFormatPipe } from '@common/pipe/money-format.pipe';
import { TooltipModule } from '@primeng/tooltip';
import { Observable } from 'rxjs';
import {PageResult} from '@shared/components/classes/page-result';
import { ModalClose } from '@shared/services/modal/modal.enum';
import { PaymentViewComponent } from '@modules/universal-billing/accounting/payments/payment-view/payment-view.component';

export enum PaymentFilter {
  All = null,
  Paid = "PAID",
  Pending = "PENDING",
  Unpaid = "UNPAID",
  Cancelled = "CANCELED",
}

@Component({
  selector: 'app-payments',
  standalone: true,
  imports: [PageTitleComponent, CommonModule, NgbDropdownModule, PaginationModule, TranslatePipe, Table, FormsModule, PTableCellValueComponent, BadgeModule, PaymentStatusBadgeDirective, MoneyFormatPipe, TooltipModule, NgbTooltip],
  templateUrl: './payments.component.html',
  styleUrl: './payments.component.scss'
})
export class PaymentsComponent extends BasicTableComponent<Payment>{
  allFilter = PaymentFilter;
  paymentFilter: PaymentFilter = PaymentFilter.All;
  service = inject(PaymentsService);
  @Input() renterId: number;
  @Input() hideActions: boolean = false;
  breadCrumbItems!: Array<{}>;

  ngOnInit(): void {
    this.breadCrumbItems = [{label: 'MENU.ACCOUNTING'}, {label: 'MENU.TRANSACTIONS', active: true}];
    super.ngOnInit();
  }

  assignToCurrantFilter(assignCurrantFilter: PaymentFilter) {
    this.paymentFilter = assignCurrantFilter;
    this.lastTableLazyLoadEvent.filters.status = { value: assignCurrantFilter};
    this.loadData();
  }
  onSearch(value: string) {
    this.lastTableLazyLoadEvent.globalFilter = value;
    this.loadData();
  }

  getAll(params: any): Observable<PageResult<any>> {
    params.renterId = this.renterId || null
    return super.getAll(params)
  }


  onView(data: any) {
    this.translateService.get('VIEW_INTAKE').subscribe((translatedTitle) => {
      this.modalService.open({
        component: PaymentViewComponent,
        title: translatedTitle,
        modalOptions: {},
        componentOptions: {
        payment:data
        }
      }).then((res) => {
        if (res == ModalClose.SUCCESS) {
          this.loadData();
        }
      }).catch((err) => console.error(err)
      );
    });
  }
  protected readonly PaymentStatus = PaymentStatus;
}
